<template>
  <div class="menu-300-item-wrapper d-inline" @mouseleave="disableMenu">
    <template v-if="itemHaveChild">
      <span class="menu-300-item mx-1" @mouseover="activeMenu">{{ item.name }}</span>
      <!-- اضافه کردن کلاس `visible` به `sub-menu` -->
      <div :class="{'visible': megaMenuVisible}" class="p-3 position-absolute sub-menu">
        <div class="row-container">
          <div class="item-menu-title-wrapper"> <i class="bi bi-caret-left-fill"></i> {{ item.name }}</div>
          <a v-for="child in item.children" :href="child.url" class="mx-1 menu-300-item"> {{ child.name }} </a>
        </div>
      </div>
    </template>
    <m-a v-else :href="item.url" class="mx-1  menu-300-item">
      {{ item.name }}


    </m-a>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import mA from '../../Tags/A.vue'

export default defineComponent({
  name: "Menu300Item",
  components: { mA },
  data() {
    return {
      megaMenuVisible: false,
    }
  },
  props: {
    item: {}
  },
  computed: {
    itemHaveChild() {
      return this.item.children.length > 0
    }
  },
  methods: {
    activeMenu() {
      this.megaMenuVisible = true // هنگام هاور، منو باز می‌شود
    },
    disableMenu() {
      this.megaMenuVisible = false // هنگام ترک موس، منو بسته می‌شود
    },
  }
})
</script>

<style scoped>
.sub-menu {
  background: var(--secondary);
  width: 100%;
  right: 0;
  padding: 4px;
  opacity: 0;
  transform: translateY(-10px);
  transition: opacity 0.5s ease, transform 0.5s ease;
  pointer-events: none;
}

.sub-menu.visible {
  opacity: 1;
  transform: translateY(0);
  pointer-events: all;
}

.row-container {
  display: flex;
  flex-flow: column;
}

.menu-300-item {
  font-size: 13px;
  font-weight: bold;
  color: var(--dark);
  display: inline-block;
  text-decoration: none;
  cursor: pointer;
  transition: ease-in-out all .3s;
}

.menu-300-item:hover {
  color: var(--primary);
  transition: ease-in-out all .3s;
}

.item-menu-title-wrapper{
  font-size: 1.4rem;
  color: black;
  font-weight: bold;
}

.menu-300-item-wrapper:hover {
  transition: ease-in-out all .3s;
}
</style>
